<template>
        <div class="container">
            <!-- Section: Contact v.2 -->
            <section id="contact" class="section pb-5 wow fadeIn" data-wow-delay="0.3s">

                <!-- Section heading -->
                <h1 class="section-heading h1 pt-5" v-lang.schreibenSieUns>Schreiben Sie uns!</h1>
                
                <div class="row">

                    <!-- Grid column -->
                    <div class="col-md-4 col-xl-3">
                        <h4 class="text-center"  style="margin-top:13px;margin-bottom:22px;">Heimann.s Agentur</h4>
                        <ul class="contact-icons">
                            <li class="mb-1"><i class="fa fa-map-marker fa-2x"></i>
                                <p>c/o RIWAS 12, <br/>Richard-Wagner-Str. 12, <br/>50674 Köln</p>
                            </li>

                            <li class="mb-1">
                                <a href="tel:+492218469120" style="color: #757575;">
                                    <i class="fa fa-phone fa-2x"></i>
                                    <p>+ 49 (0) 221 - 846 91 20</p>
                                </a>
                                <!--<p>+ 49 (0) 221 - 846 91 20</p>-->
                            </li>

                            <li class="mb-3">
                                <a href="mailto:info@heimanns-agentur.de" style="color: #757575;">
                                    <i class="fa fa-envelope fa-2x"></i>
                                    <p>info@heimanns-agentur.de</p>
                                </a>
                                <!--<p>info@heimanns-agentur.de</p>-->
                            </li>
                            <li class="mt-4 mb-3">                        
                                <!-- Facebook -->
                                <a class="icons-sm fb-ic" 
                                    target="_blank" 
                                    href="https://www.facebook.com/pages/Heimanns-Agentur/174592245925723">
                                    <i class="fa fa-facebook"> </i></a>
                                <!-- Instagram -->
                                <a class="icons-sm fb-ic" 
                                    target="_blank" 
                                    href="https://www.instagram.com/heimann.s_agentur/">
                                    <i class="fa fa-instagram"> </i></a>
                            </li>
                        </ul>
                    </div>
                    <!-- Grid column -->

                    <!-- Grid column -->
                    <div class="col-md-8 col-xl-9">
                        <form>

                            <!-- Grid row -->
                            <div class="row">

                                <div class="col-md-6">                                    
                                    <div class="md-form" :class="{ invalid : $v.name.$error }">
                                        <input 
                                            v-model.trim="name" 
                                            @blur="$v.name.$touch()"
                                            type="text" 
                                            id="contact-name" 
                                            class="form-control">
                                        <label for="contact-name" v-lang.ihrName>Ihr Name</label>
                                        <p class="invalid-text-style" v-if="!$v.name.required && $v.name.$error">Feld muss gefüllt sein</p>
                                    </div>                                    
                                </div>

                                <div class="col-md-6">
                                   <div class="md-form" :class="{ invalid : $v.email.$error }">
                                        <input 
                                            v-model.trim="email" 
                                            @blur="$v.email.$touch()"
                                            type="email" 
                                            id="contact-email" 
                                            class="form-control" >
                                        <label for="contact-email" v-lang.ihreEmail>Ihre Email</label>
                                        <p class="invalid-text-style" v-if="!$v.email.email && $v.email.$error">Ungültiges Format</p>
                                        <p class="invalid-text-style" v-if="!$v.email.required && $v.email.$error">Feld muss gefüllt sein</p>
                                    </div>
                                </div>

                            </div>
                            <!-- Grid row -->

                            <!-- Grid row -->
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="md-form" :class="{ invalid : $v.betreff.$error }">
                                        <input 
                                            v-model.trim="betreff" 
                                            @blur="$v.betreff.$touch()"
                                            type="text" 
                                            id="contact-subject" 
                                            class="form-control">
                                        <label for="contact-subject" v-lang.betreff>Betreff</label>
                                        <p class="invalid-text-style" v-if="!$v.betreff.required && $v.betreff.$error">Feld muss gefüllt sein</p>
                                    </div>                                    
                                </div>
                            </div>
                            <!-- Grid row -->

                            <!-- Grid row -->
                            <div class="row">

                                <!-- Grid column -->
                                <div class="col-md-12">

                                    <div class="md-form" :class="{ invalid : $v.nachricht.$error }">
                                        <textarea 
                                            v-model.trim="nachricht" 
                                            @blur="$v.nachricht.$touch()"
                                            type="text" 
                                            id="contact-message" 
                                            class="md-textarea"></textarea>
                                        <label for="contact-message" v-lang.ihreNachricht>Ihre Nachricht</label>
                                        <p class="invalid-text-style" style="margin-top:-5px;" v-if="!$v.nachricht.required && $v.nachricht.$error">Feld muss gefüllt sein</p>
                                    </div>

                                </div>
                            </div>
                            <!-- Grid row -->
                            <!-- Grid row -->
                            <div class="row">

                                <!-- Grid column -->
                                <div class="col-md-12">

                                    <p style="font-size:0.9rem">
                                        Mit Nutzung des Kontaktformulars werden die angegebenen Daten vorübergehend 
                                        zwecks Kontaktaufnahme von Heimann.s Agentur verarbeitet. 
                                        Der Nutzer erklärt sich ausdrücklich mit dieser Datenverwendung einverstanden. 
                                        Weiterhin stimmt der Nutzer zu, dass die Daten (zur Zeit) unverschlüsselt übertragen werden.
                                        Nähere Informationen entnehmen Sie bitte unserer 
                                        <a href="#" data-toggle="modal" data-target=".bd-data-protection-modal-lg"><span style="color:#0188c0;">Datenschutzerklärung</span></a>. 
                                    </p>

                                    <div class="md-form">
                                        <div class="form-group checkbox-rounded-heimanns-red">
                                            <input type="checkbox" class="filled-in" id="isAgreed" v-model="isAgreed">
                                            <label for="isAgreed">Ich bin einverstanden.</label>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <!-- Grid row -->
                        </form>

                        <div class="center-on-small-only">
                            <button v-if="!isSending" :disabled="$v.$invalid || !isAgreed" @click.prevent="sendMail" class="btn btn-primary btn-rounded" v-lang.absenden>Absenden</button>

                            <div v-if="isSending" class="preloader-wrapper small active ml-5">
                                <div class="spinner-layer spinner-blue-only">
                                <div class="circle-clipper left">
                                    <div class="circle"></div>
                                </div><div class="gap-patch">
                                    <div class="circle"></div>
                                </div><div class="circle-clipper right">
                                    <div class="circle"></div>
                                </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!-- Grid column -->

                </div>

                <div class="row" v-if="isSubmitted">                
                    <div class="col mt-3">
                        <hr>
                        <div class="panel panel-default">
                            <div class="panel-heading text-center">
                                <h4 v-lang.nachrichtVersendet>Vielen Dank. Die Nachricht wurde versendet.</h4>
                            </div>
 <!--                           <div class="panel-body">
                                <p>Name: {{ message.name }}</p>
                                <p>Mail: {{ message.email }}</p>
                                <p>Betreff: {{ message.betreff }}</p>
                                <p style="white-space:pre;">Message: {{ message.nachricht }}</p>
                            </div>-->
                        </div>
                    </div>
                </div>
                <div class="row" v-if="wasResponseError">                
                    <div class="col mt-3">
                        <hr>
                        <div class="panel panel-default">
                            <div class="panel-heading text-center">
                                <h4 class="red-text" v-lang.fehlerNochmal>Ein Fehler ist aufgetreten! Bitte versuchen Sie es später erneut.</h4>
                            </div>
 <!--                           <div class="panel-body">
                                <p>Name: {{ message.name }}</p>
                                <p>Mail: {{ message.email }}</p>
                                <p>Betreff: {{ message.betreff }}</p>
                                <p style="white-space:pre;">Message: {{ message.nachricht }}</p>
                            </div>-->
                        </div>
                    </div>
                </div>
            </section> 
            <!-- Section: Contact v.2 -->
            
        </div>
  
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import url from './../config'
export default {
    data () {
        return {
            name: "",
            email: "",
            betreff: "",
            nachricht:"",
            isSubmitted: false,
            isSending: false,
            wasResponseError: false,
            lastMessage : {},
            isAgreed: false
        }
    },
    validations: {
        name: {
            required
        },
        email: {
            required,
            email
        },
        betreff: {
            required
        },
        nachricht: {
            required
        },
    },
    methods: {
        sendMail() {
            var message = {
                name : this.name,
                email: this.email,
                betreff: this.betreff,
                nachricht: this.nachricht
            }

            if (!this.wasResponseError 
              && this.lastMessage.name === message.name
              && this.lastMessage.email === message.email
              && this.lastMessage.betreff === message.betreff
              && this.lastMessage.nachricht === message.nachricht) {
                //alert("Mehrfachsendung");
                return;
            }

            this.lastMessage = message;
            
            this.isSending = true;
            this.isSubmitted = false;
            this.wasResponseError = false;
            //this.$http.post(url.scheme + '://service.heimanns-agentur.de/api/contact', message)
            this.$http.post(url.scheme + '://relaunch2018.heimanns-agentur.de/api/contact', message)
                .then(response => {
                    return response.json();
                }, error => {
                    this.wasResponseError = true;
                    this.isSending = false;
                })
                .then(data => {
                    console.log("Posted data: " + JSON.stringify(data));
                    if(!this.wasResponseError) {
                        this.isSubmitted = true;
                    }                    
                    this.isSending = false;
            });

            
        }
    }
}
</script>

<style scoped>

    .btn-primary, 
    .btn-primary:not([disabled]):not(.disabled):active {
        background-color: #0188c0!important;
        color: #fff!important;
    }
    .btn-primary:hover {
        background-color: #51b1f3!important;
    }

    .icons-sm>i {
        color: #0188c0;
    }

    .md-form.invalid input,
    .md-form.invalid textarea {
        border-bottom: 1px solid red; 
        box-shadow: 0 1px 0 0 red;
    }
    .invalid-text-style {
        margin-top:-14px;
        padding-top:0px;
        font-size:0.7rem;
        color:#757575;
    }

    input[type=text]:focus:not([readonly]),
    input[type=email]:focus:not([readonly]),
    textarea.md-textarea:focus:not([readonly]) {
        border-bottom: 1px solid #0188c0;
        box-shadow: 0 1px 0 0 #0188c0;
    }
    input[type=text]:focus:not([readonly])+label,
    input[type=email]:focus:not([readonly])+label,
    textarea.md-textarea:focus:not([readonly])+label {
        color: #0188c0;
    }

    .preloader-wrapper .spinner-blue, .preloader-wrapper .spinner-blue-only {
        border-color: #0188c0;
    }

</style>



// WEBPACK FOOTER //
// src/components/Contact.vue